module.exports = __webpack_public_path__ + "assets/images/arvore_aede1584964f8d4642f596a8dd23a6fe.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/yellow/cone/arvore.png
// module id = 192
// module chunks = 0